import { render, staticRenderFns } from "./ShippingSameAsBillingAddress.vue?vue&type=template&id=faf017a4&scoped=true"
import script from "./ShippingSameAsBillingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingSameAsBillingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf017a4",
  null
  
)

export default component.exports